import { API_CLIENT_GET_AXIOS } from "../api_call/service_instances.js";

import { REGISTER_USER } from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for create User
 * --------------------------------------------------------
 */

export default {
  createUser(regId, paltform, thisVers, user) {
    return API_CLIENT_GET_AXIOS(
      REGISTER_USER +
        "?regid=" +
        regId +
        "&platf=" +
        paltform +
        "&version=" +
        thisVers +
        "&user=" +
        user
    );
  }
};
